import React, { useState } from 'react'
import { useAppDispatch, useAppSelector } from 'redux/hooks';
import { ModalBasic } from 'components/commons/Modals';
import {setIsOrderFormModalOpen} from "../../../redux/orders/reducer";
import FormOrderUpd from "./FormOrderUpd";
import UpdList from "../UpdList";
import AddNewUpdBtn from "./UpdAdd";
import Transition from "../../../utils/Transition";
import {t} from "i18next";
import StickersList from "../../Stickers/StickersList";
import Tabs from "../../Tabs2";

const { List, Body, Tab, Panel }: any = Tabs;

const OrderFormWrapper = () => {
    const isOrderFormModalOpen = useAppSelector((state) => state.orders.isOrderFormModalOpen);
    const orderExtId = useAppSelector((state) => state.orders.orderExtId);
    const marketId = useAppSelector((state) => state.orders.marketId);
    const [isNeedClearForm, setIsNeedClearForm] = useState<boolean>(false);
    const [isFormOpen, setIsFormOpen] = useState<boolean>(false);

    const dispatch = useAppDispatch();

    const closeFeedModalHandler = () => {
        dispatch(setIsOrderFormModalOpen(false))
        setIsNeedClearForm(true)
        setIsFormOpen(false)
    }

    return (
        <ModalBasic
            id="order_form_modal"
            title={t("Order", { ns: "messages" }) +' ' + t(`${marketId}`, { ns: "messages" }) + ' № ' + orderExtId}
            modalOpen={isOrderFormModalOpen}
            setModalOpen={closeFeedModalHandler}
            customSize="max-w-2xl"
        >
            <div data-t="" className={'bg-white rounded w-full  max-h-full p-6'}>
                <Tabs>
                    <List className={'contact-list'}>
                        <Tab
                            to={t("Stickers", { ns: "messages" })}
                            className={'contact-person'}
                            containerClassName={`py-1`}
                        >
                            {t("Stickers", { ns: "messages" })}
                        </Tab>
                        <Tab
                            to={t("UPD", { ns: "messages" })}
                            className={'contact-person'}
                            containerClassName={`py-1`}
                            >
                            {t("UPD", { ns: "messages" })}
                        </Tab>
                    </List>

                    <Body>
                        <Panel
                            name={t("Stickers", { ns: "messages" })}
                            className={'contact-list-panel'}
                        >
                            <div className={'bg-white rounded w-full  max-h-full'}>
                                <StickersList />
                            </div>
                        </Panel>
                        <Panel
                            name={t("UPD", { ns: "messages" })}
                            className={'contact-list-panel'}
                        >
                            <>
                                <AddNewUpdBtn toShowUpdForm={() => setIsFormOpen(true)}/>

                                <Transition
                                    className="inset-0 z-50 overflow-hidden flex items-center justify-end transform"
                                    role="dialog"
                                    aria-modal="true"
                                    show={isFormOpen}
                                    enter="transition ease-in-out duration-200"
                                    enterStart="opacity-0 translate-y-4"
                                    enterEnd="opacity-100 translate-y-0"
                                    leave="transition ease-in-out duration-200"
                                    leaveStart="opacity-100 translate-y-0"
                                    leaveEnd="opacity-0 translate-y-4"
                                    appear={true}
                                >
                                    <FormOrderUpd
                                        // @ts-ignore
                                        isNeedClearForm={isNeedClearForm}
                                        toCloseUpdForm={() => setIsFormOpen(false)}
                                    />
                                </Transition>
                                <UpdList/>
                            </>
                        </Panel>
                    </Body>
                </Tabs>
            </div>
        </ModalBasic>
    )
}

export default OrderFormWrapper;